import { type FC, type ReactNode, useCallback, useRef, useState } from "react";
import { Tooltip } from "react-tooltip";

interface OverflowTooltipContentProps {
  children: ReactNode;
  tooltipId: string;
  tooltipText: string;
  enabled?: boolean;
}

const OverflowTooltipContent: FC<OverflowTooltipContentProps> = ({
  children,
  tooltipId,
  tooltipText,
  enabled = false,
}) => {
  const contentRef = useRef<HTMLDivElement | null>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  const checkOverflow = useCallback(() => {
    if (!enabled || tooltipText.trim() === "") {
      setIsOverflowing(false);
      return;
    }
    const el = contentRef.current;
    if (!el) return;
    setIsOverflowing(el.scrollWidth > el.clientWidth);
  }, [enabled, tooltipText]);

  const shouldShowTooltip =
    enabled && isOverflowing && tooltipText.trim() !== "";

  return (
    <>
      <div
        ref={contentRef}
        className="truncate"
        onMouseEnter={checkOverflow}
        onFocus={checkOverflow}
        data-tooltip-id={shouldShowTooltip ? tooltipId : undefined}>
        {children}
      </div>
      {shouldShowTooltip && (
        <Tooltip
          id={tooltipId}
          place="bottom"
          content={tooltipText}
          className="z-10"
        />
      )}
    </>
  );
};

export default OverflowTooltipContent;
